// Mapping catégorie → accent rose Kadelio (par défaut) + variantes par thème.
// Utilisé pour les badges, mini-thumbs et CTA contextuels dans le blog.

export const CATEGORY_ACCENT: Record<string, string> = {
  Naissance: '#DB2777',
  Mariage: '#4F46E5',
  Anniversaire: '#F59E0B',
  Noël: '#DC2626',
  'Saint-Valentin': '#BE185D',
  Crémaillère: '#84A98C',
  Entreprise: '#1f2937',
  'Vie quotidienne': '#E07856',
  Conseils: '#6b7280',
};

// Dégradés de fallback pour les thumbnails (cas où coverImage est absente).
export const CATEGORY_THUMB_GRADIENT: Record<string, string> = {
  Naissance: 'linear-gradient(135deg, #FCE7F3, #DB2777)',
  Mariage: 'linear-gradient(135deg, #E0E7FF, #4F46E5)',
  Anniversaire: 'linear-gradient(135deg, #FEF3C7, #F59E0B)',
  Noël: 'linear-gradient(135deg, #FEE2E2, #DC2626)',
  'Saint-Valentin': 'linear-gradient(135deg, #FCE7F3, #BE185D)',
  Crémaillère: 'linear-gradient(135deg, #DCE5D4, #84A98C)',
  Entreprise: 'linear-gradient(135deg, #E5E7EB, #1f2937)',
  'Vie quotidienne': 'linear-gradient(135deg, #FCDFCC, #E07856)',
  Conseils: 'linear-gradient(135deg, #F3F4F6, #6b7280)',
};

// Background "soft" (équivalent à `${accent}-100`) pour le pill catégorie sur la page article.
export const CATEGORY_SOFT_BG: Record<string, string> = {
  Naissance: '#FCE7F3',
  Mariage: '#E0E7FF',
  Anniversaire: '#FEF3C7',
  Noël: '#FEE2E2',
  'Saint-Valentin': '#FCE7F3',
  Crémaillère: '#DCE5D4',
  Entreprise: '#E5E7EB',
  'Vie quotidienne': '#FCDFCC',
  Conseils: '#F3F4F6',
};
